export const catchTJKError = response => {
  if (!response.success) throw response.error;
};
 